import React, { useEffect } from 'react';
import { Link } from 'react-router-dom'; 
import Header from'../Component/Header'
const AboutUs = () => {   
  useEffect(() => {
    document.title = ' About Us - St. Josephs School Quadian Punjab';  
}, []); 
  return (
     <> 
     <Header/>
       <div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  About Us</li>
                 <li>About Us</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h2>About Us</h2>
                    </div>
                </div>
                <div className="row">
                     <div className="col-12"> 
                     <p>St. Joseph's Convent School, Dalla Morh, Qadian is established, owned and administered by the Diocese of Jalandhar, registered charitable Society, as one among its several prestigious schools all over Punjab and certain parts of Himachal Pradesh. This is an unaided minority educational institution with all its privileges guaranteed by the Supreme Constitution of India, under the Articles 29, 30 (1). His Excellency, the Catholic Bishop of Jalandhar, appointed by the Holy Father (pope) in Rome is the Patron of this school and the President of the Society.  </p>

                     <p>The main aim of the school is to provide a sound, value based and emancipating education, designed to train its pupils to live for God and humanity, by developing their multifarious talents through manifold activities, be it moral, spiritual, intellectual, social or professional. The school strives to maintain a student-friendly ambiance and encourages its wards to develop analytical, creative and independent thinking habit and assists the students to possess holistic perspectives, all round developments, positive thinking attitude and sound domain of knowledge with particular application of it in daily living situations. </p>
                     
                     <p>St. Joseph's Convent School was established on 25th April 2012 by the Diocese of Jalandhar under the Patronage of Most Rev. Bishop Anil Jose Thomas Couto, then Bishop of the Diocese of Jalandhar and through the sustained effort of its first Director Rev. Fr. Joseph P.K. Presently the patron of the school is Most Rev. Bishop Franco Mulakkal who is also the president of the Diocese of Jalandhar, Registered Charitable Society, Registered under the Society Registration Act XXI of 1860, Vide No. 134 of 1957-1958. </p>
                     
                     <p>The School holds its status of unaided Minority Educational Institution as per the provisions guaranteed under Articles 29 & 30 of the Supreme Constitutions of India. Although it is established primarily for the benefit of the members of the minority community, admission to this school is open to the boys and girls of all communities irrespective of their religion, cast or creed as per the availability of seats. Every staff and student of this school is encouraged to admire and practice his/her religion. This is a co-educational school from Kindergarten (Nursery to class 10th. The medium of instruction is English. </p>
                     </div>
                </div>  
            </div>  
        </div>
     </>
  )
}

export default AboutUs

